import React from "react";
import { FaEnvelope, FaWhatsapp, FaFolderOpen } from "react-icons/fa";
import { ShortcutItem } from "./types";

/**
 * Default shortcut menu items
 */
export const getDefaultMenuItems = (): ShortcutItem[] => {
  const isHomePage =
    typeof window !== "undefined" && window.location.pathname === "/";

  return [
    {
      label: "Get a Free Quote",
      icon: <FaEnvelope className="text-xl" />,
      href: isHomePage ? "#contact-us" : "/#contact-us",
      external: false,
    },
    {
      label: "Got a project in mind? Let’s WhatsApp",
      icon: <FaWhatsapp className="text-xl" />,
      href: "https://wa.me/919023550069",
      external: true,
    },
    {
      label: "View Portfolio",
      icon: <FaFolderOpen className="text-xl" />,
      href: "/portfolio",
      external: false,
    },
  ];
};
